// FETCH INIT_STATE
export const FETCH_INIT_STATE_REQUEST = 'FETCH_INIT_STATE_REQUEST';
export const FETCH_INIT_STATE_SUCCESS = 'FETCH_INIT_STATE_SUCCESS';
export const FETCH_INIT_STATE_FAIL = 'FETCH_INIT_STATE_FAIL';

// FETCH FREQUENCY_REQUEST
export const FETCH_FREQUENCY_REQUEST = 'FETCH_FREQUENCY_REQUEST';
export const FETCH_FREQUENCY_SUCCESS = 'FETCH_FREQUENCY_SUCCESS';
export const FETCH_FREQUENCY_FAIL = 'FETCH_FREQUENCY_FAIL';

// FETCH CLAUSES_REQUEST
export const FETCH_CLAUSES_REQUEST = 'FETCH_CLAUSES_REQUEST';
export const FETCH_CLAUSES_SUCCESS = 'FETCH_CLAUSES_SUCCESS';
export const FETCH_CLAUSES_FAIL = 'FETCH_CLAUSES_FAIL';

// FETCH ICONS
export const FETCH_ICONS_REQUEST = 'FETCH_ICONS_REQUEST';
export const FETCH_ICONS_SUCCESS = 'FETCH_ICONS_SUCCESS';
export const FETCH_ICONS_FAIL = 'FETCH_ICONS_FAIL';

// FETCH USER INFO
export const FETCH_USER_LANGUAGE = 'FETCH_USER_LANGUAGE';

// UPDATE MENUDRAWER SETTINGS
export const UPDATE_MENUDRAWER_SETTINGS = 'UPDATE_MENUDRAWER_SETTINGS';

// TOGGLE ABOUT
export const TOGGLE_ABOUT = 'TOGGLE_ABOUT';

// FETCH_SERVICEINFO
export const FETCH_SERVICEINFO_REQUEST = 'FETCH_SERVICEINFO_REQUEST';
export const FETCH_SERVICEINFO_SUCCESS = 'FETCH_SERVICEINFO_SUCCESS';
export const FETCH_SERVICEINFO_FAIL = 'FETCH_SERVICEINFO_FAIL';
